/*
 * Botón "Comprar ahora" custom (Salty Dogs).
 * Agrega la variante seleccionada al carrito y manda directo al checkout.
 * No usa el payment_button de Shopify porque ese no deja cambiar texto ni color.
 */
(function () {
  if (window.__saltyBuyNowReady) return;
  window.__saltyBuyNowReady = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setLoading(btn, isLoading) {
    var spinner = btn.querySelector('.hdt-loading__spinner');
    if (spinner) spinner.hidden = !isLoading;
    btn.classList.toggle('is-loading', isLoading);
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    btn.disabled = isLoading;
  }

  function toggleError(form, message) {
    var box = form.querySelector('.hdt-form__message-wrapper');
    if (!box) return;
    var text = box.querySelector('.hdt-error-message');
    if (message) {
      if (text) text.textContent = message;
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-salty-buy-now]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var form = document.getElementById(btn.dataset.formId) || btn.closest('form');
    if (!form) return;

    toggleError(form, '');
    setLoading(btn, true);

    var data = new FormData(form);
    data.delete('sections');
    data.delete('sections_url');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.body.description || result.body.message || 'Error');
        }
        window.location.href = root() + 'checkout';
      })
      .catch(function (error) {
        setLoading(btn, false);
        toggleError(form, error.message || 'No se pudo agregar el producto.');
      });
  });
})();
